<template>
  <div v-if="company" class="navbar" :style="'--highlight-color: '+ company.highlight +';'">
    <navbar-user />
    <div class="nav">
      <ul>
        <router-link tag="li" :to="'/yritys/'+company.id"><a>Vuosikello</a></router-link>
        <router-link
          v-if="company"
          tag="li"
          :to="{ name: 'EditCompany', params: { companyId: company.id } }"
        >
          <a>Asetukset</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'Admin' }" v-if="userIsAdmin">
          <a>Hallinta</a>
        </router-link>
      </ul>
    </div>
    <navbar-footer />

    <!-- <navbar-categories /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";

// import NavbarCategories from "@/components/NavbarCategories";
import NavbarUser from "@/components/NavbarUser";
import NavbarFooter from "@/components/NavbarFooter";

export default {
  components: {
    // NavbarCategories,
    NavbarUser,
    NavbarFooter,
  },
  computed: {
    ...mapState(["user", "company", "userIsAdmin"]),
  },
};
</script>

<style lang="scss">
.navbar {
  display: none;
  max-width: 20rem;
  min-width: 20rem;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: white;
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
  box-shadow: $shadow_sm;
  @include bp(lg) {
    display: block;
  }
}
.nav {
  padding: 2.5em 0;
  border-top: 1px solid $whitegray;
  border-bottom: 1px solid $whitegray;
  ul {
    padding: 0 0.5em 0 2.5em;
    list-style-type: none;
    li {
      position: relative;
      width: 100%;
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: -2.5em;
        width: 0;
        height: 100%;
        background: $lightred;
        border-top-right-radius: 2.5em;
        border-bottom-right-radius: 2.5em;
        transition: $transition;
      }
      a {
        position: relative;
        display: block;
        padding: 0.5em 0;
        color: $gray;
        text-decoration: none;
      }
      &.router-link-exact-active {
        &:before {
          width: 100%;
          transition: $transition;
        }
        a {
          color: white;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
